<template>
  <small class="d-activity-timestamp text-grey-dark">{{ activity.time_ago }} ago</small>
</template>

<script>
export default {
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
};
</script>
